import { Navigate, useLocation, useParams } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";

export default function JobPostDetailsPage() {
  usePageTitle("/jobs/job-post/:jobPostId", "Jobs | Job Post Details");
  const location = useLocation();
  const { jobPostId } = useParams();

  if (!jobPostId) return null;

  return <Navigate to={`${location.pathname}/details`} replace />;
}
